"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var conversationGet = exports.conversationGet = function conversationGet(state) {
  return state.conversation.base;
};
var conversationGetProcessing = exports.conversationGetProcessing = function conversationGetProcessing(state) {
  return state.conversation.processing;
};
var conversationGetQueue = exports.conversationGetQueue = function conversationGetQueue(state) {
  return state.conversation.queue;
};

var conversationGetLastItemIndex = exports.conversationGetLastItemIndex = function conversationGetLastItemIndex(state) {
  return conversationGet(state).length - 1;
};